import { validateTicketsSearch } from '@support/features/tickets-filters';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { protectedRoute } from './_root';

// Admin/Operations support-ticket management page (all-org list + triage).
// Regular reporters use the header drawer instead (My/Recent tabs). Access
// is gated by role in route-permissions.ts; the API enforces the
// fine-grained support_tickets:*:any permissions.
export const supportManagementRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: 'support-management',
  component: lazyRouteComponent(() =>
    import('@support/pages/support-management').then((m) => ({
      default: m.SupportManagementPage,
    }))
  ),
  validateSearch: validateTicketsSearch,
});
